import moment from 'moment-timezone';
import 'moment/locale/es';

// Loading a moment locale also makes it the global default - keep English global and opt
// into Spanish per call via formatLocalDate / getWeekdayLabels.
moment.locale('en');

export const formatLocalDate = (date, pattern, spanishLanguagePref) =>
  moment(date).locale(spanishLanguagePref ? 'es' : 'en').format(pattern);

export const getWeekdayLabels = (spanishLanguagePref) =>
  moment.localeData(spanishLanguagePref ? 'es' : 'en').weekdaysMin()
    .map((day) => day.charAt(0).toUpperCase() + day.slice(1));

// Shared by MobileDateTimePicker.js and DesktopDateTimePicker.js - both need the same
// date -> time-slot map from scheduleAppt's pipe-delimited strings, just render it with
// different controls (native selects vs button grids). Dates and each date's slots are in
// chronological order regardless of the order installWindow arrives in, so dates[0] /
// slotsByDate[dates[0]][0] is always the first available appointment.
export const buildSlotsByDate = (scheduleAppt) => {
  const slots = (scheduleAppt || []).map((item) => {
    const parts = item.split('|');
    const times = parts.filter((p) => p !== '0');
    return {
      date: moment(parts[0]).format('YYYY-MM-DD'),
      start: moment.utc(times[0]).valueOf(),
      label: `${moment.utc(times[0]).format('h:mm a')} to ${moment.utc(times[1]).format('h:mm a')}`,
    };
  });
  slots.sort((a, b) => a.date.localeCompare(b.date) || a.start - b.start);

  const map = {};
  slots.forEach(({ date, label }) => {
    map[date] = map[date] ? [...map[date], label] : [label];
  });
  return map;
};

// Reverses the "YYYY-MM-DD to h:mm a to h:mm a" string handleSave/handleConfirm write to
// rawScheduleDateTime, so re-opening the appointment step for editing can pre-select the
// customer's already-saved date/time instead of resetting to the first available slot.
export const parseRawScheduleDateTime = (rawScheduleDateTime) => {
  if (!rawScheduleDateTime) {
    return { date: '', time: '' };
  }
  const [date, ...timeParts] = rawScheduleDateTime.split(' to ');
  return { date, time: timeParts.join(' to ') };
};
